var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 783,
    height: 800,
    viewBox: "0 0 783 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M782.5 398.763C782.5 618.726 607.435 797.026 391.5 797.026C175.565 797.026 0.5 618.726 0.5 398.763C0.5 178.8 175.565 0.5 391.5 0.5C607.435 0.5 782.5 178.8 782.5 398.763Z",
    stroke: "url(#paint0_linear_6940_2345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.991 1.49463V799.519",
    stroke: "url(#paint1_linear_6940_2345)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44678 395.275H782.511",
    stroke: "#B8A3F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M404.224 1.99365C467.843 88.7245 485.46 655.965 400.309 798.024",
    stroke: "url(#paint2_linear_6940_2345)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M415.477 1.99365C548.587 88.2261 574.034 661.447 413.03 795.531",
    stroke: "url(#paint3_linear_6940_2345)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431.14 2.99023C629.337 99.1917 648.912 672.911 422.331 795.531",
    stroke: "url(#paint4_linear_6940_2345)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M447.78 4.48608C706.66 116.638 712.043 689.361 431.63 794.535",
    stroke: "url(#paint5_linear_6940_2345)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M463.925 7.47534C767.336 121.621 772.23 677.895 444.839 793.038",
    stroke: "url(#paint6_linear_6940_2345)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M499.16 15.4517C816.275 155.517 811.871 673.909 459.031 791.045",
    stroke: "url(#paint7_linear_6940_2345)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M568.164 42.8657C850.043 224.801 810.404 660.948 501.119 780.577",
    stroke: "url(#paint8_linear_6940_2345)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M632.759 85.2334C834.872 245.237 829.978 602.13 569.63 752.164",
    stroke: "url(#paint9_linear_6940_2345)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M376.227 1.99536C312.608 88.7263 294.991 655.966 380.142 798.025",
    stroke: "url(#paint10_linear_6940_2345)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M364.973 1.99536C231.863 88.2278 206.415 661.449 367.42 795.533",
    stroke: "url(#paint11_linear_6940_2345)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M349.314 2.9917C151.118 99.1932 131.543 672.913 358.124 795.532",
    stroke: "url(#paint12_linear_6940_2345)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M332.675 4.48633C73.7952 116.638 68.4121 689.361 348.825 794.535",
    stroke: "url(#paint13_linear_6940_2345)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M316.526 7.47681C13.1142 121.623 8.22047 677.897 335.612 793.039",
    stroke: "url(#paint14_linear_6940_2345)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M281.29 15.4531C-35.8246 155.519 -31.4203 673.91 321.42 791.047",
    stroke: "url(#paint15_linear_6940_2345)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.29 42.8667C-69.5898 224.802 -29.9505 660.949 279.335 780.578",
    stroke: "url(#paint16_linear_6940_2345)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.692 85.2334C-54.4203 245.237 -49.5265 602.13 210.821 752.164",
    stroke: "url(#paint17_linear_6940_2345)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M278.457 16.9478H504.548M207.987 46.3565H573.55M147.794 87.7281H635.701M96.4094 137.573H686.596M55.7912 194.397H724.767M27.4075 258.698H758.044M6.85375 325.989H776.151M5.875 465.057H776.641M23.0031 531.85H759.513M730.639 596.151H52.3656M91.0263 653.473H691.489M643.041 703.318H139.964M195.753 743.693H586.274M523.634 774.098H259.861",
    stroke: "url(#paint18_linear_6940_2345)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M326.41 791.544H455.605",
    stroke: "#6637ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6940_2345",
    x1: 391.5,
    y1: 0,
    x2: 391.5,
    y2: 797.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6940_2345",
    x1: 392.491,
    y1: 1.49463,
    x2: 392.491,
    y2: 799.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6940_2345",
    x1: 429.241,
    y1: 1.99365,
    x2: 429.241,
    y2: 798.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6940_2345",
    x1: 468.872,
    y1: 1.99365,
    x2: 468.872,
    y2: 795.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6940_2345",
    x1: 504.192,
    y1: 2.99023,
    x2: 504.192,
    y2: 795.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6940_2345",
    x1: 536.795,
    y1: 4.48608,
    x2: 536.795,
    y2: 794.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6940_2345",
    x1: 567.901,
    y1: 7.47534,
    x2: 567.901,
    y2: 793.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6940_2345",
    x1: 594.819,
    y1: 15.4517,
    x2: 594.819,
    y2: 791.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6940_2345",
    x1: 629.623,
    y1: 42.8657,
    x2: 629.623,
    y2: 780.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6940_2345",
    x1: 672.594,
    y1: 85.2334,
    x2: 672.594,
    y2: 752.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6940_2345",
    x1: 351.21,
    y1: 1.99536,
    x2: 351.21,
    y2: 798.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6940_2345",
    x1: 311.578,
    y1: 1.99536,
    x2: 311.578,
    y2: 795.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6940_2345",
    x1: 276.263,
    y1: 2.9917,
    x2: 276.263,
    y2: 795.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6940_2345",
    x1: 243.66,
    y1: 4.48633,
    x2: 243.66,
    y2: 794.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6940_2345",
    x1: 212.55,
    y1: 7.47681,
    x2: 212.55,
    y2: 793.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6940_2345",
    x1: 185.632,
    y1: 15.4531,
    x2: 185.632,
    y2: 791.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6940_2345",
    x1: 150.83,
    y1: 42.8667,
    x2: 150.83,
    y2: 780.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6940_2345",
    x1: 107.857,
    y1: 85.2334,
    x2: 107.857,
    y2: 752.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6940_2345",
    x1: 391.258,
    y1: 16.9478,
    x2: 391.258,
    y2: 774.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6637ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.2c974180cc0a8da06bfc78ba2031a3ab.svg";
export { ForwardRef as ReactComponent };